<script>
import formCreate from '@/components/iglobalwin/formPanelGroups/index.js';
import formComponents from '@/components/iglobalwin/formComponents/common/index.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import utils from '@/utils';
import {
	required,
} from '@/utils/validate';

const {
	skyProKeywords,
	selectProductDetail
} = formComponents;

function isEditPage(vm) {
	const templateId = vm.$route.query.templateId;
	const isEdit = templateId !== null && templateId !== undefined;
	return isEdit;
}

function getGroups(pageData, vm) {
	let { isEdit, domain } = pageData;

	return {
		pos: {
			title: '关键词',
			items: {
				tips: {
					label: '',
					type: selectProductDetail,
					value: [],
					domain: domain,
				},
				addKeyWordBaseDto: {
					label: '',
					type: skyProKeywords,
					value: {
						keyWordDtos: [],
						negativeKeyWords: []
					},
					keywordsList: [],
					excludedKeywordsList: [],
					load: false,
					domain: domain,
					onChange: valueChange,
				}
			},
		},
	};
}

// 预加载数据
async function pageData(vm) {
	const isEdit = isEditPage(vm);
	const domain = await getServiceDomain(vm); // 获取服务单域名
	if (isEdit) {
		const detail = await getKsTemplateById(vm); //获取模板详情
		return {
			isEdit,
			domain,
		};
	} else {
		return {
			isEdit,
			domain,
		};
	}
}

function getFormData({ pageData }, vm) {
	let { isEdit, detail } = pageData;
	const groups = getGroups(pageData, vm);
	if (isEdit) {
		return SetGroupFormValue(groups, detail);
	} else {
		return groups;
	}
}
// 编辑表单时value值回显填入
function SetGroupFormValue(groups, obj) {
	Object.keys(groups).forEach(groupKey => {
		Object.keys(groups[groupKey].items).forEach(itemKey => {
			// 如果obj[itemKey]不存在或者为空值时，表单则取自己原来的默认值。
			groups[groupKey].items[itemKey].value = obj[itemKey] || groups[groupKey].items[itemKey].value;
		});
	});
	return groups;
}

// 处理表单变化
async function valueChange(vm, field) {
	if(vm.errorMsgList && vm.errorMsgList.length) {
		vm.validateAll().then(msg => {
			vm.errorMsgList = msg;
		})
	}
	if(field.itemName === 'tips') {
		// 如果产品值改变，获取关键词数据
		let res = await productkeyword(field.value);
		vm.formData.fields.addKeyWordBaseDto.keywordsList = res.data || [];
		vm.formData.fields.addKeyWordBaseDto.excludedKeywordsList = res.data.removeKeywordList || [];
		vm.formData.fields.addKeyWordBaseDto.load = false;
	}
}

// 根据选中的产品或产品分类 获取关键词
async function productkeyword(obj) {
	let res = await googleads.getKeywordProduct({
			url: obj[0].path,
	});
	return res;
};

// 获取服务单域名
async function getServiceDomain(obj) {
	let res = await googleads.getServiceDomain();
	return res.data;
};

// 提交
async function submit(data) {
	data['adGroup'] = this.$route.query.resourceName;
	delete data['tips'];
	const res = await googleads.addKeyword(data);
	goBack(this,res);
	if(res.status == 200 && !res.data.error) {
		this.$message.success('新建关键词成功！');
	}else {
		this.$message.error('新建关键词失败！');
	}
}

function titleTooltipInfo() {
	return {
		tit: '新建关键词',
		item: {
			'所属广告系列': this.$route.query.adSeriesName + '（ID：'+this.$route.query.adSeriesId+'）',
			'所属广告组': this.$route.query.adGroupName + '（ID：'+this.$route.query.adGroupId+'）'
		}
	};
}

// 返回
function goBack(vm) {
	// 确认后返回关键词列表，选中父级广告组
	vm.$router.push({
		name: 'accountManagement',
		query: {
			adSeriesId: vm.$route.query.adSeriesId,
			adSeriesName: vm.$route.query.adSeriesName,
			adGroupId: vm.$route.query.adGroupId,
			adGroupName: vm.$route.query.adGroupName,
			resourceName: vm.$route.query.resourceName,
			tabValueKeyword: '', // 是否选中关键词tab列表
		},
	});
}

// 取消-返回
function cancel(vm) {
	vm.$confirm('将不保存已填写的内容,确认后返回关键词列表，选中父级广告组', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning',
	})
		.then(() => {
			goBack(vm);
		})
		.catch(() => {
			return;
		});
}

export default formCreate({
	getFormData,
	load: {
		pageData,
	},
	submit,
	cancel,
	showNavPanel: true,
	goBack,
	labelWidth: '180px',
	titleTooltip: true,
	titleTooltipInfo,
});
</script>
